// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","OverlayedTextBackground":"_1XsUSH","centerText":"bkkLVk","OverlayedTextWrapper":"_1r0N1-","OverlayedTextTitle":"_36zBYv","fadeInFrames":"_2ZoX3f"};